import React, { useState, useEffect } from "react";
import { useForm } from 'react-hook-form'

import { connect } from 'react-redux';

import { Actions as ACTIONS } from 'store/ads/action';
import PageHeading from 'components/PageHeading';

import {
	BrowserRouter as Router,
	Switch,
	Route,
	Link,
	Redirect,
	useLocation,
	useParams
} from "react-router-dom";

import { format } from 'date-fns'

import Select from 'react-select';
import { selectDefaultStyle } from 'styles/selectDefaultStyle'

const IndicatorsContainer = () => (
	<div style={{ display: "flex", padding: "6.5px" }}>
		<svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
			<path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
		</svg>
	</div>
)

const TeamMembers = ({ ads, adsNextToken, listAds, locations }) => {

	const [filter, setFilter] = useState("Active")

	useEffect(() => {
		console.log('id', ads)
		if (!(ads)) {
			console.log('getBusiness')
			listAds(1000, adsNextToken)
		}
	}, []);

	// if (!teamMembers){

	// 	return (
	// 		<div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
	// 			Loading...
	// 		</div>
	// 	)
	// }

	return (
		<React.Fragment>
			<PageHeading withCreate={true} />
			<div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
				<div className="flex flex-col">

					<div className="sm:px-12 lg:px-12" style={{ width: "100%" }}>

						<div className="pt-6 grid grid-cols-12 gap-12">
							<div className="col-span-3 col-start-10">
								<Select
									className="block form-select w-full p-0 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
									styles={selectDefaultStyle}
									placeholder="Filter"
									onChange={(selectedValue) => {
										setFilter(selectedValue.value)
									}}
									options={[
										{
											label: "Active",
											value: "Active",
										},
										{
											label: "Disabled",
											value: "Disabled",
										}
									]}
									components={{ IndicatorsContainer }}
								/>
							</div>
						</div>
					</div>

					<div className="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
						<div className="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200">
							<table className="min-w-full">
								<thead>
									<tr>
										<th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
											Name
										</th>
										<th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
											Dates
										</th>
										<th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
											Location
										</th>
										<th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
											Status
										</th>
										<th className="px-6 py-3 border-b border-gray-200 bg-gray-50"></th>
									</tr>
								</thead>
								<tbody className="bg-white">
									{ads && ads.map((ad, index) => (

										<tr key={ad.id}>
											<td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 font-medium text-gray-900">
												{ad.name}
											</td>
											<td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500">
												{format(new Date(ad.startDate), "do MMM yyyy")} - {format(new Date(ad.endDate), "do MMM yyyy")}
											</td>
											<td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500">
												{ad.locationID && locations.find(item => item.id == ad.locationID).name}
											</td>
											<td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500">
												<div className="ml-2 flex-shrink-0 flex">
													{ad.status}
												</div>
											</td>
											<td className="px-6 py-4 whitespace-no-wrap text-right border-b border-gray-200 text-sm leading-5 font-medium">
												<Link to={`/ad/${ad.id}`} className="text-indigo-600 hover:text-indigo-900 focus:outline-none focus:underline">Edit</Link>
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	)
}


const mapStateToProps = (state) => {
	return {
		ads: state.ad.list,
		locations: state.location.list,
		adsNextToken: state.ad.listNextToken,
	}
}

const mapDispatchToProps = dispatch => ({
	listAds: (limit, nextToken) => dispatch(ACTIONS.getList(limit, nextToken)),
	// timesheetUpdateSaveStatus: (status) => dispatch(ACTIONS.timesheetUpdateSaveStatus(status))
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(TeamMembers)